import React from 'react'
import {Lang} from 'yougile-lang'

import {Avatar} from '@components/common/base/avatar'
import {UserName} from '@components/common/base/user-name'
import {ReactedUser} from './types'
import {TwReactionHint, TwReactionHintItem} from './containers'

const MAX_SHOWN = 8

interface Props {
  users: ReactedUser[]
}

export const ReactionHint = ({users}: Props) => {
  users = users.sort((a, b) => b.timestamp - a.timestamp)
  const restCount = users.length - MAX_SHOWN

  return (
    <TwReactionHint>
      {users.slice(0, MAX_SHOWN).map(user => (
        <TwReactionHintItem key={user.userId}>
          <Avatar userId={user.userId} size={20} hideStatus hideOutline />
          <UserName
            className="text-grey-l40"
            context="override"
            userId={user.userId}
          />
        </TwReactionHintItem>
      ))}
      {restCount > 0 && Lang.msg.emojiReactions.andMore(restCount)}
    </TwReactionHint>
  )
}
